import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(79, 172, 254, 0.3);
    border-radius: 3px;
    
    &:hover {
      background: rgba(79, 172, 254, 0.5);
    }
  }
`;

const AlertItem = styled.div`
  padding: 12px;
  border-radius: 8px;
  border-left: 4px solid ${props => {
    switch (props.severity) {
      case 'high': return '#dc3545';
      case 'medium': return '#ffc107';
      case 'low': return '#17a2b8';
      default: return '#6c757d';
    }
  }};
  background: ${props => {
    switch (props.severity) {
      case 'high': return '#f8d7da';
      case 'medium': return '#fff3cd';
      case 'low': return '#d1ecf1';
      default: return '#f8f9fa';
    }
  }};
`;

const AlertHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
`;

const AlertTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #2c3e50;
`;

const AlertTime = styled.div`
  font-size: 11px;
  color: #6c757d;
`;

const AlertMessage = styled.div`
  font-size: 12px;
  color: #495057;
  line-height: 1.4;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;
`;

const AlertsPanel = ({ alerts = [] }) => {
  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'high': return '🚨';
      case 'medium': return '⚠️';
      case 'low': return 'ℹ️';
      default: return '📢';
    }
  };

  if (alerts.length === 0) {
    return (
      <EmptyState>
        <div style={{ fontSize: '32px', marginBottom: '12px' }}>✅</div>
        <div style={{ fontWeight: '600', marginBottom: '4px' }}>No Active Alerts</div>
        <div style={{ fontSize: '12px' }}>All systems operating normally</div>
      </EmptyState>
    );
  }

  return (
    <Container>
      {alerts.map(alert => (
        <AlertItem key={alert.id} severity={alert.severity}>
          <AlertHeader>
            <AlertTitle>
              {getSeverityIcon(alert.severity)} {alert.title}
            </AlertTitle>
            <AlertTime>
              {formatTime(alert.timestamp)}
            </AlertTime>
          </AlertHeader>
          <AlertMessage>
            {alert.message}
          </AlertMessage>
          {alert.source && (
            <div style={{ fontSize: '10px', color: '#6c757d', marginTop: '4px' }}>
              Source: {alert.source}
            </div>
          )}
        </AlertItem>
      ))}
    </Container>
  );
};

export default AlertsPanel; 